module.exports = __webpack_public_path__ + "img/full0-min.0df832af.png";